/* Naoko — LP „Lista Black Friday VIP" (docs/lp-bf-vip-plan.md): wspólny JS sekcji naoko-bfv-*.
   - hero: film z muzyką startuje WYCISZONY (autoplay), dźwięk włącza i wycisza okrągły przycisk
     (decyzja 2026-10-27, wcześniej film bez audio), plik desktop/mobile wg progu 761 px, plakat
     do startu, pauza poza ekranem; przy błędzie oryginału przełączenie na rendition Shopify;
     prefers-reduced-motion / oszczędzanie danych = sam plakat (bez przycisku),
   - kotwice (#zapis) przewijane z odjęciem sticky nagłówka i banerów,
   - formularz: walidacja 1:1 z paczki przed NATYWNYM submitem (captcha Shopify blokuje AJAX),
     imię do strony podziękowania przez sessionStorage (nie URL — PII w GA4/Meta),
   - kopiowanie linku do zaproszenia (origin + pathname), zielony stan do odświeżenia strony,
   - strona podziękowania (?typ=1): cała LP, sekcja zapisu pokazuje kartę podziękowania
     i strona przewija się do niej (decyzja 2026-10-27, cofnięte „tylko karta”),
   - potwierdzony zapis: atrybut data-bfv-signup (hak GTM) + event Meta, raz na wysłanie formularza.
   Inicjalizacja idempotentna (data-bfv-ready) — edytor motywu re-renderuje sekcje. */
(function () {
  var DESK = '(min-width: 761px)';
  var ORDER = ['fname', 'email', 'consent'];
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function headerOffset() {
    var cs = getComputedStyle(document.body);
    return (parseFloat(cs.getPropertyValue('--header-height')) || 0) +
      (parseFloat(cs.getPropertyValue('--naoko-sticky-banners-height')) || 0);
  }

  function scrollToEl(el, smooth) {
    var y = Math.max(0, el.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0) - headerOffset());
    if (smooth && !reduceMotion()) {
      window.scrollTo({ top: y, behavior: 'smooth' });
      return;
    }
    /* Skok bez animacji: base.css daje html scroll-behavior: smooth, więc „auto” też animowało
       (~1 s), a w karcie w tle animacja staje i strona zostawała na górze. */
    var html = document.documentElement;
    var prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
    html.style.scrollBehavior = prev;
  }

  /* ---------------- Hero: film ---------------- */
  function initHero(root) {
    if (root.dataset.bfvReady) return;
    root.dataset.bfvReady = '1';
    var v = root.querySelector('.nbfv-hero__video');
    if (!v) return;
    var conn = navigator.connection;
    if (reduceMotion() || (conn && conn.saveData)) return;

    var mq = window.matchMedia(DESK);
    var visible = true;
    v.muted = true;
    v.defaultMuted = true;
    var snd = root.querySelector('[data-bfv-sound]');

    function pick(d, m) { return mq.matches ? (d || m) : (m || d); }
    function want() { return pick(v.dataset.srcD, v.dataset.srcM); }
    function fallback() { return pick(v.dataset.fbD, v.dataset.fbM); }
    function play() {
      var p = v.play();
      if (p && p.catch) p.catch(function () {
        /* Przeglądarka nie puści filmu z dźwiękiem bez gestu (np. powrót do kadru po przewinięciu):
           wracamy do wyciszenia i gramy dalej. Bez dźwięku nie gra = tryb oszczędzania (zostaje plakat). */
        if (!v.muted) { setMuted(true); v.play().catch(function () {}); }
      });
    }
    /* Stan przycisku: aria-pressed = dźwięk włączony; data-gtm-label = akcja następnego kliknięcia
       (GTM czyta ją przy kliknięciu, zanim stan się zmieni). */
    function sync() {
      if (!snd) return;
      var on = !v.muted;
      snd.setAttribute('aria-pressed', String(on));
      snd.setAttribute('aria-label', on ? snd.dataset.labelOff : snd.dataset.labelOn);
      snd.setAttribute('data-gtm-label', on ? 'wycisz' : 'wlacz');
    }
    function setMuted(m) {
      v.muted = m;
      setTimeout(sync, 0);
    }
    if (snd) {
      snd.addEventListener('click', function () {
        setMuted(!v.muted);
        if (!v.muted) play();
      });
      sync();
    }
    function load(src) {
      if (!src || v.getAttribute('src') === src) return;
      root.classList.remove('is-playing');
      v.src = src;
      if (visible) play();
    }

    v.addEventListener('playing', function () {
      root.classList.add('is-playing');
      if (snd) snd.hidden = false;
    });
    v.addEventListener('error', function () {
      var fb = fallback();
      if (fb && v.getAttribute('src') !== fb) {
        v.src = fb;
        if (visible) play();
      }
    });

    load(want());
    var onChange = function () { load(want()); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (!v.getAttribute('src')) return;
        if (visible) play();
        else v.pause();
      }).observe(root);
    }
  }

  /* ---------------- Zapis ---------------- */
  function cleanName(val) {
    var n = String(val || '').replace(/\s+/g, ' ').trim().slice(0, 30);
    if (!n) return '';
    var first = n.charAt(0);
    try { first = first.toLocaleUpperCase('pl-PL'); } catch (e) { first = first.toUpperCase(); }
    return first + n.slice(1);
  }

  function initForm(root) {
    var form = root.querySelector('form.nbfv-form');
    if (!form || form.dataset.bfvReady) return;
    form.dataset.bfvReady = '1';

    var field = {};
    var err = {};
    ORDER.forEach(function (k) {
      field[k] = form.querySelector('[data-bfv-field="' + k + '"]');
      err[k] = form.querySelector('[data-bfv-err="' + k + '"]');
    });
    if (!field.fname || !field.email || !field.consent) return;

    function isBad(k) {
      if (k === 'fname') return field.fname.value.trim().length < 2;
      if (k === 'email') return !EMAIL_RE.test(field.email.value.trim());
      return !field.consent.checked;
    }
    function mark(k, bad) {
      field[k].setAttribute('aria-invalid', String(bad));
      if (err[k]) err[k].hidden = !bad;
    }

    /* Bramka: wszystkie błędy naraz, kursor na pierwszym. true = wolno wysłać. */
    function gate() {
      var first = null;
      ORDER.forEach(function (k) {
        var bad = isBad(k);
        mark(k, bad);
        if (bad && !first) first = k;
      });
      if (first) {
        field[first].focus();
        return false;
      }
      var nm = cleanName(field.fname.value);
      field.fname.value = nm;
      try {
        sessionStorage.setItem('bfv:name', nm);
        sessionStorage.setItem('bfv:pending', '1');
      } catch (_) {}
      return true;
    }

    form.noValidate = true;
    /* Capture na document: przed captcha-bootstrapem Shopify i apkami. */
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (!gate()) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
    /* captcha-bootstrap po challenge'u wysyła formularz programowo (bez eventu submit). */
    var nativeSubmit = HTMLFormElement.prototype.submit.bind(form);
    form.submit = function () { if (gate()) nativeSubmit(); };

    /* Komunikat znika, gdy klientka poprawia pole. */
    ORDER.forEach(function (k) {
      field[k].addEventListener(k === 'consent' ? 'change' : 'input', function () {
        if (field[k].getAttribute('aria-invalid') === 'true') mark(k, false);
      });
    });

    /* Powrót z błędem serwera: imię wraca z sessionStorage. */
    if (root.hasAttribute('data-bfv-error')) {
      try { field.fname.value = sessionStorage.getItem('bfv:name') || field.fname.value; } catch (_) {}
    }
  }

  function initZapis(root) {
    if (root.dataset.bfvReady) return;
    root.dataset.bfvReady = '1';
    initForm(root);

    var isTyp = root.classList.contains('is-typ');
    if (isTyp || root.hasAttribute('data-bfv-error')) {
      /* Cała LP zostaje (decyzja 2026-10-27) — przewijamy do karty podziękowania / formularza.
         Od razu, zanim zniknie biała nakładka preload-screen (skoku nie widać; czekanie na load
         pokazywało przez kilka sekund hero). Po load wyrównanie jeszcze raz — wysokość nagłówka
         ustala się później — chyba że klientka w międzyczasie sama przewinęła stronę.
         Bez programowego fokusu na nagłówku: *:focus-visible z base.css rysował wokół niego
         czarny obrys (outline + box-shadow). */
      var moved = false;
      var onMove = function () { moved = true; };
      ['wheel', 'touchstart', 'keydown'].forEach(function (t) {
        window.addEventListener(t, onMove, { passive: true, once: true });
      });
      scrollToEl(root, false);
      var again = function () {
        if (!moved) scrollToEl(root, false);
      };
      if (document.readyState === 'complete') setTimeout(again, 0);
      else window.addEventListener('load', again);
    }

    /* Potwierdzony zapis = pierwsze wyświetlenie podziękowania po wysłaniu formularza
       (znacznik bfv:pending z gate()). Zużywamy go od razu, więc odświeżenie strony ani wejście
       z linku nie liczą się drugi raz. Hak dla GTM (Google Ads, TikTok, GA4) to atrybut
       data-bfv-signup na sekcji, czytany na DOM Ready — bez dataLayer.push (AIIT-234). */
    var confirmed = false;
    if (isTyp) {
      try {
        confirmed = sessionStorage.getItem('bfv:pending') === '1';
        if (confirmed) sessionStorage.removeItem('bfv:pending');
      } catch (_) {}
    }
    if (!confirmed) return;
    root.setAttribute('data-bfv-signup', '');

    /* Event Meta (nazwa z ustawień sekcji; puste = brak). */
    var ev = root.getAttribute('data-meta-event');
    if (!ev) return;
    var tries = 0;
    (function fire() {
      if (typeof window.fbq === 'function') {
        window.fbq('track', ev, { content_name: root.getAttribute('data-tag') || '' });
      } else if (tries++ < 60) {
        setTimeout(fire, 500);
      }
    })();
  }

  /* ---------------- Kopiowanie linku ---------------- */
  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (_) {}
    ta.remove();
  }

  function onCopy(btn) {
    var url = window.location.origin + window.location.pathname;
    var done = function () {
      btn.classList.add('is-copied');
      var label = btn.querySelector('[data-bfv-copy-label]');
      if (label && btn.dataset.copied) label.textContent = btn.dataset.copied;
      var sec = btn.closest('.nbfv');
      var live = sec && sec.querySelector('[data-bfv-live]');
      if (live) live.textContent = btn.dataset.live || '';
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { legacyCopy(url); done(); });
    } else {
      legacyCopy(url);
      done();
    }
  }

  /* ---------------- Delegacja kliknięć ---------------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var copy = e.target.closest('.nbfv [data-bfv-copy]');
    if (copy) {
      onCopy(copy);
      return;
    }
    var a = e.target.closest('.nbfv a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    scrollToEl(target, true);
    try { history.replaceState(null, '', '#' + id); } catch (_) {}
  });

  function scrollToHash() {
    var id = window.location.hash.slice(1);
    if (!id || new URLSearchParams(window.location.search).get('typ') === '1') return;
    var t = document.getElementById(id);
    if (t && t.closest('.nbfv')) scrollToEl(t, false);
  }
  window.addEventListener('hashchange', scrollToHash);

  function init(scope) {
    var r = scope || document;
    r.querySelectorAll('.nbfv-hero').forEach(initHero);
    r.querySelectorAll('.nbfv-zapis').forEach(initZapis);
  }

  init();
  if (document.readyState === 'complete') scrollToHash();
  else window.addEventListener('load', scrollToHash);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
